export class Certificado {

    // Certificado en Base64
    public certificate: string;
    // Respuesta
    public serialNumber: string;
    public name: string;
    public sigAlgOID: string;
    public sigAlgName: string;
    public fechInicio: string;
    public fechFinal: string;
    public logEstatusRegistro: string;
    public logUsernameRegistro: string;
    public logFechaRegistro: string;
    public logUsernameModificacion: string;
    public logFechaModificacion: string;

    constructor(certificate: string = "",
                serialNumber: string = null,
                name: string = null,
                sigAlgOID: string = null,
                sigAlgName: string = null,
                fechInicio: string = null,
                fechFinal: string = null,
                logEstatusRegistro: string = null,
                logUsernameRegistro: string = null,
                logFechaRegistro: string = null,
                logUsernameModificacion: string = null,
                logFechaModificacion: string = null) {

        this.certificate = certificate;
        this.serialNumber = serialNumber;
        this.name = name;
        this.sigAlgOID = sigAlgOID;
        this.sigAlgName = sigAlgName;
        this.fechInicio = fechInicio;
        this.fechFinal = fechFinal;
        // CAMPOS DE AUDITORIA
        this.logEstatusRegistro = logEstatusRegistro;
        this.logUsernameRegistro = logUsernameRegistro;
        this.logFechaRegistro = logFechaRegistro;
        this.logUsernameModificacion = logUsernameModificacion;
        this.logFechaModificacion = logFechaModificacion;

    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/certificado.ts